import * as Animate from "react-reveal";
import { ArrowUpRight } from "../../../components/svgs";

const platforms = [
  {
    tag: "LEARN",
    title: "UtivaLearn",
    desc:
      "Build practical skills through live instruction, projects, assessment and portfolio development.",
    cta: "Explore programs",
    href: "#programs",
  },
  {
    tag: "HIRE",
    title: "UtivaHire",
    desc:
      "Discover and evaluate professionals through focused matching and skills evidence.",
    cta: "Find talent",
    href: "#hire",
  },
  {
    tag: "PAY",
    title: "UtivaPay",
    desc:
      "Support contracts, multi-currency payroll and workforce operations across borders.",
    cta: "Manage and pay",
    href: "#workforce",
  },
];

const HomePlatformSection = () => {
  return (
    <section className="bg-white pb-16 md:pb-24 px-4">
      <div className="container mx-auto">
        <div className="text-center max-w-[900px] mx-auto pt-16 md:pt-24 pb-12 md:pb-16">
          <Animate.Fade bottom>
            <p className="flex items-center font-poppins justify-center gap-3 text-primary text-sm font-extrabold tracking-[0.1em] uppercase mb-5">
              <span className="w-8 h-[3px] bg-secondary inline-block"></span>
              Learning connected to demand
            </p>
            <h2 className="text-primary font-poppins font-bold tracking-[-0.045em] leading-[1.12] text-3xl md:text-4xl lg:text-5xl mb-5">
              Your training is connected to real workforce demand.
            </h2>
            <p className="text-gray text-base font-poppins leading-[1.8]">
              Utiva does not develop courses in isolation. We work with
              companies, study changing skill requirements, assess talent and
              support global hiring. This helps us build learning pathways
              around capabilities businesses actually need.
            </p>
          </Animate.Fade>
        </div>

        <div className="grid md:grid-cols-3 gap-4">
          {platforms.map((platform) => (
            <Animate.Fade bottom key={platform.tag}>
              <article className="border border-hire-line bg-white rounded-[22px] min-h-[340px] flex flex-col p-7 shadow-course-card">
                <span className="text-secondary font-poppins tracking-[0.11em] text-sm font-extrabold">
                  {platform.tag}
                </span>
                <h3 className="text-primary font-bold font-poppins mt-auto text-[27px]">
                  {platform.title}
                </h3>
                <p className="text-gray text-sm font-poppins my-4 leading-[1.72]">
                  {platform.desc}
                </p>
                <a
                  href={platform.href}
                  className="text-primary mt-2.5 font-poppins text-sm font-bold"
                >
                  {platform.cta}{" "}
                  <b aria-hidden="true">
                    <ArrowUpRight className="w-3.5 h-3.5 inline-block" />
                  </b>
                </a>
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomePlatformSection;
